import { FC, Fragment } from "react";
import { ASSET_PREFIX, colors } from "utils/constants";

type WinnerDetails = {
  rank: number;
  leaderboard_photo_location?: string | null;
  leaderboard_username?: string | null;
  initials: string;
  points?: number;
};

type LeaderboardWinnerRowProps = {
  winnerDetails: WinnerDetails;
};

export const LeaderboardWinnerRow: FC<LeaderboardWinnerRowProps> = ({ winnerDetails }) => {
  const { rank, leaderboard_photo_location, initials, points, leaderboard_username } = winnerDetails;
  let rankShadow: string, crownImageName: string | undefined;

  switch (rank) {
    case 1:
      rankShadow = '2px -2.2px gold';
      crownImageName = 'crown-1st.svg';
      break;
    case 2:
      rankShadow = '2px -2.2px #AAA';
      crownImageName = 'crown-2nd.svg';
      break;
    case 3:
      rankShadow = '2px -2.2px goldenrod';
      crownImageName = 'crown-3rd.svg';
      break;
    default:
      rankShadow = 'none';
      break;
  }

  return (
    <div className="leaderboardTableRow">
      <p style={{ fontWeight: 900, margin: '1em', textShadow: rankShadow }}>
        {rank}
      </p>

      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
        }}
      >
        <div className="positionLeaderboardRow">
          <div className="initialsCircle" style={{ margin: '0.5em' }}>
            {crownImageName && (
              <img
                src={`${ASSET_PREFIX}/images/leaderboard/${crownImageName}`}
                style={{
                  position: 'absolute',
                  left: 'calc(50% - 13px)',
                  top: '-19px',
                  width: '26px',
                  height: '26px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 1,
                }}
                alt=""
              />
            )}

            {initials}

            {leaderboard_photo_location && (
              <img
                src={leaderboard_photo_location}
                style={{
                  width: '100%',
                  height: '100%',
                  position: 'absolute',
                  objectFit: 'cover',
                  left: 0,
                  top: 0,
                  borderRadius: '50%',
                }}
                alt=""
              />
            )}
          </div>

          <h5
            style={{
              margin: '1em',
              fontSize: '0.9em',
              textAlign: 'left',
              flexGrow: 1,
              wordBreak: 'break-all',
            }}
          >
            {leaderboard_username}
          </h5>

          {points !== undefined && (
            <p style={{ fontWeight: 900, margin: '1em' }}>
              {points.toLocaleString()}
            </p>
          )}
        </div>
      </div>

      <style jsx>{`
        .leaderboardTableRow {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .positionLeaderboardRow {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .initialsCircle {
          width: 40px;
          height: 40px;
          background-color: ${colors.primaryBrandGray};
          border-radius: 20px;
          box-shadow: 0 0 5px ${colors.brand.neon};
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          position: relative;

          font-size: 1.3em;
          font-weight: bold;
          -webkit-text-fill-color: transparent;
          -webkit-text-stroke-width: 1.5px;
          -webkit-text-stroke-color: #59ffde;
          text-shadow: 0 0 12px rgba(155, 155, 255, 0.3);
        }
      `}</style>
    </div>
  );
};

type LeaderboardPositionWinnersTableProps = {
  winners: WinnerDetails[];
};

const LeaderboardPositionWinnersTable: FC<LeaderboardPositionWinnersTableProps> = ({ winners }) => (
  <div className='leaderboardPositionWinnersTable'>
    { winners.map((winner, i) =>
      <Fragment key={i}>
        { i !== 0 &&
          <div className='separator' style={{ width: '90%', margin: '0 auto', height: '2px' }} />
        }

        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          <LeaderboardWinnerRow winnerDetails={winner} />
        </div>
      </Fragment>
    )}

    <style jsx>{`
      .leaderboardPositionWinnersTable {
        background-color: white;
        padding: 1em;
        width: 100%;
        border-radius: 4px;
        border: 2px solid #DDD;
        
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        font-size: 1.2em;
        flex-grow: 1
      }
      
      @media(max-width: 375px) {
        .leaderboardPositionWinnersTable {
          padding: 1em 0.2em;
        }
      }
    `}</style>
  </div>
);

export default LeaderboardPositionWinnersTable;